// ======================================================================
// File Name       : userHistoryStudent
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import { callPythonApi, commonCallApi } from '../../utils/ApiUtils';
import { getQuestionHistoryReviewHtml } from '../../utils/DrillByStdUtils';
import { downloadFile } from '../../utils/index';

export function postGetUserHistoryStudentDetailContainer(studentId) {
  return commonCallApi({
    path: 'userHistory/student/GetDetail',
    data: { studentId },
  });
}

export function postUserGroupRelationGetList(data) {
  return commonCallApi({
    path: 'userGroupRelation/GetList',
    data: { ...data },
  });
}

export function postUserGetList(data) {
  return commonCallApi({
    path: 'user/GetList',
    data: { ...data },
  });
}

export function postGetCourseByUserList(data) {
  return commonCallApi({
    path: 'learningOperation/GetStatusCourse',
    data: { ...data },
  });
}

export function postEachUserCourseStatusCount(data) {
  return commonCallApi({
    path: 'learningOperation/EachUserCourseStatusCount',
    data: { ...data },
  });
}

export function postGetHistoryListByCourseList(data) {
  return commonCallApi({
    path: 'learningOperation/GetHistoryList',
    data: { ...data },
  });
}

export function postGetStatusItem(data) {
  return commonCallApi({
    path: 'learningOperation/GetStatusItem',
    data: { ...data },
  });
}

export function postGetCourseList(data) {
  return commonCallApi({
    path: 'course/GetList',
    data: { ...data },
  });
}

export function postGetContentList(data) {
  return commonCallApi({
    path: 'content/GetList',
    data: { ...data },
  });
}

export function requestQuestionUseRecordByStd(data) {
  return commonCallApi({
    path: 'QuestionUseRecordInfoByUser',
    drillServer: true,
    data,
  });
}

export function requestPartQuestionRecordByStd(data) {
  return commonCallApi({
    path: 'PartsQuestionUseRecordInfoByUser',
    drillServer: true,
    data,
  });
}

export function requestDrillEnforceHistoryByStd(data) {
  return commonCallApi({
    path: 'DrillEnforceHistoryInfoByStd',
    drillServer: true,
    data,
  });
}

export function requestQuestionHistoryReviewHtml(params) {
  return getQuestionHistoryReviewHtml(params);
}

export function requestDrillEnforceHistoryInfoByHash(data) {
  return commonCallApi({
    path: 'DrillEnforceHistoryInfoByHash',
    drillServer: true,
    data,
  });
}

// Step 10.0.0 START
export function postGetStatusBox(data) {
  return commonCallApi({
    path: 'learningOperation/GetStatusBox',
    data: { ...data },
  }).then((camelizeJson) => {
    const url = camelizeJson && camelizeJson.csvfileUrl ? camelizeJson.csvfileUrl : null;
    downloadFile(url);
  });
}

export function postGetStatusCourse(data) {
  return commonCallApi({
    path: 'learningOperation/GetStatusCourse',
    data: { ...data },
  }).then((camelizeJson) => {
    const url = camelizeJson && camelizeJson.csvfileUrl ? camelizeJson.csvfileUrl : null;
    downloadFile(url);
  });
}

// Step 10.0.0 END
